export const FINASTERIDE_UPSELL = "FINASTERIDE_UPSELL";
export const URGENCY_WIDGET_COUNTDOWN_TIMER = "urgency_widget_countdown_timer";
export const URGENCY_WIDGET_PEOPLE_WATCHING = "urgency_widget_people_watching";
export const OESTRA_SENSITIVE_QUESTIONS = "OESTRA_SENSITIVE_QUESTIONS";
export const OESTRA_SUPPORT_SCREEN = "OESTRA_SUPPORT_SCREEN";
export const OESTRA_DETAILS_SCREEN = "OESTRA_DETAILS_SCREEN";
export const OESTRA_QUIZ_WELCOME_SCREEN = "OESTRA_QUIZ_WELCOME_SCREEN";
export const OESTRA_QUIZ_FREE_VISIT_CTA = "OESTRA_QUIZ_FREE_VISIT_CTA";
export const LIBIDA_3_MONTHS_PLAN = "LIBIDA_3_MONTHS_PLAN";
export const LIBIDA_PQP_PLAN_SELECTOR_VARIANT = "LIBIDA_PQP_PLAN_SELECTOR_VARIANT";
export const LIBIDA_PQP_PLAN_SELECTOR_VARIATION = {
    TWO_MONTH_DEFAULT: "redesign_two_month_default",
    THREE_MONTH_DEFAULT: "redesign_three_month_default",
} as const;
export const REDIRECT_TO_MENO_PQP = "REDIRECT_TO_MENO_PQP";
export const GET_STARTED_REDESIGN = "GET_STARTED_REDESIGN";
export const FC_PQP_MOST_POPULAR_BADGE = "FC_PQP_MOST_POPULAR_BADGE";
export const GWP_CURRENT_PQP_CHECKOUT = "GWP_CURRENT_PQP_CHECKOUT";
export const TOTAL_VALUE = "TOTAL_VALUE";
export const LP_CTA_COPY_VARIANT = "LP_CTA_COPY_VARIANT";
export const TRUSTED_REVIEWS_COMPONENTS_VARIANT = "TRUSTED_REVIEWS_COMPONENTS_VARIANT";
export const TRUSTED_REVIEWS_LAYOUT_VARIANTS = "TRUSTED_REVIEWS_LAYOUT_VARIANTS";
export const LIBIDA_QUIZ_REDESIGN = "LIBIDA_QUIZ_REDESIGN";
export const LIBIDA_LP_VARIATION = "LIBIDA_LP_VARIATION";
export const LIBIDA_PDP = "LIBIDA_PDP";
export const LIBIDA_PDP_NEW_HOW_TO_USE = "LIBIDA_PDP_NEW_HOW_TO_USE";
export const CHECKOUT_HIDE_INTERCOM = "CHECKOUT_HIDE_INTERCOM";
export const CHECKOUT_REDESIGN = "CHECKOUT_REDESIGN";
export const CHECKOUT_SUBSCRIPTION_UPGRADE = "CHECKOUT_SUBSCRIPTION_UPGRADE";
export const EXPRESS_CHECKOUT_VALUE_PROPS = "EXPRESS_CHECKOUT_VALUE_PROPS";
export const FEATURED_IN = "FEATURED_IN";
export const HP_HERO_CTA_COPY = "HP_HERO_CTA_COPY";
export const FOOTER_LINK_TEXT_AA = "FOOTER_LINK_TEXT_AA";
